import { render, staticRenderFns } from "./LayoutSelect.vue?vue&type=template&id=5ac33c28&scoped=true&"
import script from "./LayoutSelect.vue?vue&type=script&lang=js&"
export * from "./LayoutSelect.vue?vue&type=script&lang=js&"
import style0 from "./LayoutSelect.vue?vue&type=style&index=0&id=5ac33c28&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ac33c28",
  null
  
)

export default component.exports